
// Use this error object if you need to redirect to root /admin
function RedirectableError(message, destination) {
  this.name = 'RedirectableError';
  this.message = message;
  this.destination = destination;
}
RedirectableError.prototype = new Error();

export default RedirectableError;
